

import * as Configuration from '../../../app.constants.js';

export class TriageService {

  dropdownItems = {
    sites: [],
    channels: [],
    weekDays: [],
    bhNbh: [],
    bhOrWallClock: [],
    tags: [],
    nonRoutingtags: [],
    routingTag: [],
    users: [],
  }

  constructor($http, DropdownItemsFactory, $translate, $state) {
    this.$http = $http;
    this.DropdownItemsFactory = DropdownItemsFactory;
    this.$translate = $translate;
    this.$state = $state;
  }

  _triageConfigurationURL(companyId) {
    return Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/parameters/triage-configuration';
  }

  getTriageConfiguration(companyId) {
    return this.$http.get(this._triageConfigurationURL(companyId));
  }

  getTriageConfigurationRuleUniqueId(companyId) {
    return this.$http.post(this._triageConfigurationURL(companyId) + '/rule-unique-id');
  }

  updateTriageConfiguration(companyId, config) {
    const clonedConfig = angular.copy(config);
    clonedConfig.rules.forEach(rule => {
      _deleteFrontendFields(rule);
      _removeSpecialRoutingTagId(rule);
    });
    return this.$http.put(this._triageConfigurationURL(companyId), clonedConfig);
  }

  buildDropdownItems(company, sites, groups, tagsGroups) {
    const sortItems = (a, b) => {
      let result = a.type - b.type;
      if (!result) {
        return a.sortKey.localeCompare(b.sortKey)
      }
      return result;
    }
    const sitesNotInGroup = sites.filter(site => !site.site_group && !site.site_group_id)
    this.dropdownItems = {
      siteIds: this.DropdownItemsFactory.buildSiteItems(sitesNotInGroup || []).sort(sortItems),
      siteGroupIds: this.DropdownItemsFactory.buildSiteGroupItems(groups || []).sort(sortItems),
      channels: this.DropdownItemsFactory.buildChannelItems(sites),
      weekDays: this.DropdownItemsFactory.buildWeekDays(),
      bhNbh: this.DropdownItemsFactory.buildBhNbh(),
      bhOrWallClock: this.DropdownItemsFactory.buildBhOrWallClock(),
      tags: this.DropdownItemsFactory.buildTagItems(tagsGroups),
      nonRoutingtags: this.DropdownItemsFactory.buildTagItems(tagsGroups.filter(tag_group => tag_group.is_routing === 0)),
      routingTag: this.DropdownItemsFactory.buildRoutingTagItemsWithSpecialAnyItem(tagsGroups),
      users: this.DropdownItemsFactory.buildUserItems(company),
      ratingOperators: this.DropdownItemsFactory.buildRatingOperatorItems(),
    };
    this.dropdownItems.sitesMap = new Map();
    this.dropdownItems.sites = [...this.dropdownItems.siteGroupIds, ...this.dropdownItems.siteIds]
      .map(item => {
        const result = { ...item, key: `${item.isGroup ? 'siteGroup' : 'site'}|${item.id}` };
        this.dropdownItems.sitesMap.set(result.key, result);
        return result
      });
    return this.dropdownItems;
  }

  goToTriageRule(ruleId) {
    const triageState = 'auth.alcmeon.fuse.parameters.triage';
    this.$state.go(triageState, { blinkRuleId: ruleId });

  }

  getHtmlRuleId(ruleId) {
    return `rule:${ruleId}`;
  }

  static TriageFactory($http, DropdownItemsFactory, $translate, $state) {
    return new TriageService($http, DropdownItemsFactory, $translate, $state);
  }
}

TriageService.TriageFactory.$inject = ['$http', 'DropdownItemsFactory', '$translate', '$state'];


function _deleteFrontendFields(rule) {
  if (rule.type === 'default') {
    delete rule.title;
    delete rule.siteIds;
    delete rule.siteGroupIds;
    delete rule.conditionLabel;
    delete rule.actionLabel;
  }
  delete rule.sitesSelectedPreview;
  delete rule.sites;
}

function _removeSpecialRoutingTagId(rule) {
  if (rule.triggerEvent &&
    rule.triggerEvent.typeCode === 'routed-to' &&
    rule.triggerEvent.parameters &&
    rule.triggerEvent.parameters.routingTagId === -1
  ) {
    // Backend expects no routing tag id for this case
    delete rule.triggerEvent.parameters.routingTagId;
  }
}